



























































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Prop, Component, Vue } from "vue-property-decorator";

@Component({
  name: "userTerm",
})
export default class UserTerm extends Vue {
  private isOpen: boolean = false;
}
